import { render, staticRenderFns } from "./UserImport.vue?vue&type=template&id=d5aec06e&"
import script from "./UserImport.vue?vue&type=script&lang=js&"
export * from "./UserImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports